import ActiveRecord from './active_record/base'

class ExportTable extends ActiveRecord {
	static tableName = 'export2Tables'

	kind() {
		if (this.draft) return 'draft'
		if (this.stock) return 'stock'
		return 'normal'
	}

	taxonomy() {
		const taxonomy = this.modelConfig?.useExportTaxonomy()
		return taxonomy?.tables[this.table_name]
	}

	filterableColumnNames() {
		const groupNames = this.filtered_column_groups
		const columnNames = this.columns._map('column')
		return columnNames.filter(columnName => groupNames.some(groupName => columnName.startsWith(groupName)))
	}

	async export(params = {}) {
		const res = await this.resourceReq('export', {...params, method: 'post'})
		if (res.ok) await this.modelConfig?.exportOnSuccess?.(res)
		return res
	}

	async duplicate() {
		const res = await this.resourceReq('duplicate', {method: 'post'})
		if (res.ok) {
			await this.modelConfig?.duplicateOnSuccess?.(res)
		}
	}
}

export default ExportTable
